/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VariableSettingDto { 
    nickname?: string;
    show?: boolean;
    variable_id?: string;
    custom_unit?: string;
    original_unit?: string;
    scaling_factor?: number;
    latest_value?: number;
}

